import { ApplicationElement, html } from '@effectivastudio/lit-components';
import '@effectivastudio/lit-components/components/avatar/element.js';
import '@effectivastudio/lit-components/components/timeago/element.js';
import '@effectivastudio/lit-components/components/icon/element.js';
import CardHeader from '../card_header/element.js';
import '../origin/element.js';
import style from './style.lit.css';

/**
 * @prop cardType - Card type icon (options: event, date, discussion, engagement, marketplace, news, organize, poll).
 * @prop createdAt - Card's created date.
 * @prop url - URL for card details. (optional)
 *
 * @slot origin - For Origin component.
 * @slot publisherIcon - For publisher icon (user picture or group icon).
 * @slot publisher - For publisher's name and link (user full name or group title + member link or group link).
 * @slot default - For title.
 *
 * @cssprop --color - Component primary text color.
 * @cssprop --color-secondary - Component secondary text color.
 * @cssprop --avatar-size - For avatar size
 * @cssprop --link-text - For link color
 */

export default class CardV1 extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    cardType: { type: String },
    createdAt: { type: Date },
    url: { type: String, reflect: true },
  };

  constructor() {
    super();

    this.addEventListener('click', this);
  }

  /** @internal */
  get iconName() {
    return CardHeader.TYPE_ICON_NAMES[this.cardType];
  }

  handleEvent(e) {
    if (e.type === 'click') this.handleClick(e);
  }

  handleClick(e) {
    if (!this.url || e.target.tagName !== 'XS-CARD-V1') return;

    this.shadowRoot.querySelector('a').click();
  }

  renderSlot() {
    return html`<slot></slot>`;
  }

  renderSlotWithLink() {
    return html`<a href=${this.url}>${this.renderSlot()}</a>`;
  }

  render() {
    return html`
      <header>
        <slot name="publisherIcon"></slot>
        <div class="content">
          <slot name="publisher"></slot>
          <div class="info">
            <ef-timeago .timestamp=${this.createdAt}></ef-timeago>
            <slot name="origin"></slot>
          </div>
        </div>
        <ef-icon name=${this.iconName}></ef-icon>
      </header>
      ${this.url ? this.renderSlotWithLink() : this.renderSlot()}
    `;
  }
}

customElements.get('xs-card-v1') || customElements.define('xs-card-v1', CardV1);
